import type { ModelResults } from 'api';

export const getPhotoVariant = (modelResults?: ModelResults): 'success' | 'warning' | 'success-warning' | undefined => {
  if (!modelResults) return undefined;

  if (modelResults.outputs?.[0]?.image_rejected) {
    return 'warning';
  }

  if (modelResults.accepted) {
    return 'success';
  }

  if (modelResults.outputs?.[0]?.highest_grade_name === 'Reject') {
    return 'warning';
  }

  return 'success-warning';
};
